import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BbitI18n, BbitLanguage } from '@bbitgmbh/bbit.utils';
import { BbitWebShopCartService } from '@bbitgmbh/webshop.sdk';
import { BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { NavService } from './nav.service';
import { NavOverlayService } from './nav-overlay/nav-overlay.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [NgIcon, RouterLink, AsyncPipe, I18nPipe],
})
export class NavComponent implements OnInit {
  public BbitI18n = BbitI18n;
  public BbitLanguage = BbitLanguage;
  constructor(
    public website: BbitWebsiteService,
    public cart: BbitWebShopCartService,
    public nav: NavService,
    public overlay: NavOverlayService,
  ) {}

  ngOnInit(): void {}
}
